import styled from 'styled-components'
import { FeatureIcon } from 'builder/components/FeatureIcon'

export const Icon = styled(FeatureIcon)`
  width: 20px;
  height: 20px;
`
